<template>
  <div class="title">
    <div
      class="main-title"
      style="font-size: 28px; font-weight: 600; color: #525252"
    >
      {{ title }}
    </div>
    <div
      class="sub-title"
      style="font-size: 13px; font-weight: 500; color: #6e737f"
    >
      {{ subtitle }}
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "title",
    "subtitle",
  ],
};
</script>